import clone from "just-clone";
import { defineStore } from "pinia";
import { RouteRecordNormalized } from "vue-router";
import { UserDataInterface } from "@/types/users";
import { OrganizationInterface } from "@/types/organizations";

const userDataDefault: UserDataInterface = {
  id: "logged_out",
  email: "john_doe@example.com",
  first_name: "John",
  last_name: "Doe",
  role: "staff",
  sub_role: "",
  is_org_admin: false,
  is_loc_admin: false,
};

const organizationDefault: OrganizationInterface = {
  id: "default",
  name: "default",
  locations: [],
  trial_access: true,
};

export const useStore = defineStore("main", {
  state: () => ({
    latestFromRoute: { matched: [] as RouteRecordNormalized[] },
    loggedIn: false,
    userData: clone(userDataDefault),
    organization: clone(organizationDefault),
  }),
  actions: {
    logIn(userData: UserDataInterface) {
      this.userData = userData;
      this.loggedIn = true;
    },
    logOut() {
      this.loggedIn = false;
      this.userData = clone(userDataDefault);
    },
    setOrganization(organization: OrganizationInterface) {
      this.organization = organization;
      let changed = false;
      for (const location of this.organization.locations) {
        if (location.trial_access) {
          changed = true;
          this.organization.trial_access = true;
          break;
        }
      }
      if (!changed) {
        this.organization.trial_access = false;
      }
    },
  },
});
